import React from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-table-6/react-table.css';
import PasswordHeader from './components/Password/PasswordHeader';
import PasswordCell from './components/Password/PasswordCell';
import OwnedCell from './components/OwnedCell';
import OpeningCell from './components/OpeningCell';
import SelectedCell from './components/SelectedCell/SelectedCell';
import LinkedVulns from './components/LinkedVulns';
import LeakDateCell from './components/LeakDateCell';

/**
 * Credentials table (Credentials screen).
 * ctx: `{ hidePass, setHidePass, isFetching }`
 */
const credentialsSchema = {
  id: 'credentials',
  ordering: {},
  columns: [
    {
      header: () => (<SelectedCell isHeader />),
      id: 'selected',
      accessor: 'Selected',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <SelectedCell rowInfo={ rowInfo } showSkeleton={ isFetching } />
    }, {
      header: () => (<FormattedMessage id="credentials.table.columns.endpoint" />),
      id: 'endpoint',
      accessor: 'endpoint',
      visible: true,
      sortable: true,
      resizable: true,
      maxWidth: 187,
      minWidth: 187,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <OpeningCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'endpoint' } />
    }, {
      header: () => (<FormattedMessage id="credentials.table.columns.username" />),
      id: 'username',
      accessor: 'username',
      visible: true,
      sortable: true,
      resizable: true,
      maxWidth: 201,
      minWidth: 201,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <OpeningCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'username' } />
    }, {
      header: (_, { hidePass, setHidePass }) => (<PasswordHeader hidePass={ hidePass } setHidePass={ setHidePass } />),
      id: 'password',
      accessor: 'password',
      visible: true,
      sortable: ({ hidePass }) => !hidePass,
      resizable: true,
      maxWidth: 177,
      minWidth: 177,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching, hidePass }) => <PasswordCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'password' } hidePass={ hidePass } />
    }, {
      header: () => (<FormattedMessage id="credentials.table.columns.linkedVulnerability" />),
      id: 'linked_vulnerability',
      accessor: 'linked_vulnerability',
      visible: true,
      sortable: false,
      resizable: true,
      maxWidth: 249,
      minWidth: 249,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <LinkedVulns showSkeleton={ isFetching } rowInfo={ rowInfo } />
    }, {
      header: () => (<FormattedMessage id="credentials.table.columns.owned" />),
      id: 'owned',
      accessor: 'owned',
      visible: true,
      sortable: true,
      resizable: false,
      maxWidth: 157,
      minWidth: 157,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <OwnedCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'owned' } />
    }, {
      header: () => (<FormattedMessage id="credentials.table.columns.leakDate" />),
      id: 'leak_date',
      accessor: 'leak_date',
      visible: true,
      sortable: true,
      resizable: false,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { isFetching }) => <LeakDateCell showSkeleton={ isFetching } rowInfo={ rowInfo } />
    }
  ]
};

export default credentialsSchema;
